interface Props {
  title: string
  description: string
}

export default function Title({ title, description }: Props) {
  return (
    <div className="flex w-full flex-col">
      <h2 className="text-heading2 text-text">{title}</h2>
      <p className="text-regular text-text-light">{description}</p>
    </div>
  )
}
